import styled from 'styled-components';

// CONSTANTS
import { WHITE, MAIN_BLACK } from '@/constants/colors';

export const ShareContainer = styled.ul`
  list-style: none;
  font-size: 2.4rem;
  margin: 0;
  padding: 0;

  .share {
    &__item {
      display: inline-block;
      color: ${p => (p.black ? MAIN_BLACK : WHITE)};
      transition: color 0.4s;

      &:hover {
        color: ${p => (p.black ? MAIN_BLACK : WHITE)};
      }

      &:not(:last-of-type) {
        margin-right: 40px;
      }

      a {
        text-decoration: none;
        color: ${p => (p.black ? MAIN_BLACK : WHITE)};
        display: inline-block;
        transition: color 0.4s;

        &:hover {
          color: ${p => (p.black ? MAIN_BLACK : WHITE)};
        }
      }
    }

    &--copy-link {
      cursor: pointer;
    }
  }

  svg {
    font-size: 2.4rem;
  }
`;

export default ShareContainer;
